<template>
  <page-list
    :list="list"
    :columns="columns"
    :group-actions="groupActions"
    :single-actions="singleActions"
    :export-data-options="exportDataOptions"
    :show-page="false"
    :defaultSearchKey="defaultSearchKey"
    :placeholder="$t('system.common_log_filter_tip')" />
</template>

<script>
import { getTimeRangeFilter } from '@/utils/common/tableFilter'
import regexp from '@/utils/regexp'
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'
import columnsMixin from '../mixins/columns'

export default {
  name: 'LogManageList',
  mixins: [WindowsMixin, ListMixin, columnsMixin],
  props: {
    id: String,
  },
  data () {
    return {
      list: this.$list.createList(this, {
        id: this.id,
        resource: 'commandlogs',
        apiVersion: 'v1',
        getParams: {
          // service: 'compute',
          ascending: false,
          descending: false,
          scope: this.$store.getters.scope,
        },
        filterOptions: {
          name: {
            label: 'ID',
            filter: true,
            formatter: val => {
              return `id.equals("${val}")`
            },
          },
          ip: {
            label: 'IP',
            filter: true,
            formatter: val => {
              return `notes.contains("${val}")`
            },
          },
          ps1: {
            label: 'PS1',
            filter: true,
            formatter: val => {
              return `ps1.contains("${val}")`
            },
          },
          command: {
            label: this.$t('common.command'),
            filter: true,
            formatter: val => {
              return `command.contains("${val}")`
            },
          },
          user: {
            label: this.$t('system.text_533'),
            filter: true,
            formatter: val => {
              return `user.contains("${val}")`
            },
          },
          obj_type: {
            label: this.$t('table.title.obj_type'),
            dropdown: true,
            multiple: true,
            items: [
              { label: this.$t('common_239'), key: 'server' },
              { label: this.$t('dictionary.host'), key: 'host' },
            ],
            filter: true,
            formatter: val => {
              return `obj_type.contains("${val}")`
            },
          },
          obj_name: {
            label: this.$t('table.title.res_name'),
            filter: true,
            formatter: val => {
              return `obj_name.contains("${val}")`
            },
          },
          login_user: {
            label: this.$t('common.login_user'),
            filter: true,
            formatter: val => {
              return `login_user.contains("${val}")`
            },
          },
          start_time: getTimeRangeFilter({ label: this.$t('common_156'), field: 'start_time' }),
        },
      }),
      exportDataOptions: {
        items: [
          { label: '#ID', key: 'id' },
          { label: 'PS1', key: 'ps1' },
          { label: this.$t('common.command'), key: 'command' },
          { label: this.$t('system.text_533'), key: 'user' },
          { label: this.$t('table.title.obj_type'), key: 'obj_type' },
          { label: this.$t('table.title.res_name'), key: 'obj_name' },
          { label: 'IP', key: 'notes' },
          { label: this.$t('common.login_user'), key: 'login_user' },
          { label: this.$t('common_156'), key: 'start_time' },
        ],
        limit: () => Object.keys(this.list.data).length,
        export: 'custom',
        notCombineListParams: true,
        exportType: {
          custom: { label: this.$t('cloudenv.text_328'), key: 'custom' },
        },
      },
    }
  },
  created () {
    // this.eventsM = new this.$Manager('actions', 'v1')
    this.list.fetchData()
  },
  methods: {
    defaultSearchKey (search) {
      if (regexp.isIPv4(search)) {
        return 'ip'
      }
      return 'name'
    },
  },
}
</script>
